import api from 'api'

interface IMeData {
  id: number
  email: string
  identifier: string
  name: string
  lastname: string
  fullName: string
  token: string
}

const getMe = async () => {
  const response = await api.get<IMeData>('/me')
  return response.data
}

export default getMe
